var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"Stats"},_vm._l((_vm.stats),function(stat,key){return _c('li',{key:key,staticClass:"Stats__item"},[_c('span',{staticClass:"Stats__icon"},[_vm._v(_vm._s(_vm.icons[key]))]),_vm._v(" "),_c('strong',{class:{
        warning: stat < 50,
        danger: stat < 20
    }},[_vm._v("\n      "+_vm._s(stat)+"\n    ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a005a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
// module id = KWAn
// module chunks = 1